import { render } from "./DashboardDetails.vue?vue&type=template&id=f4f0c5a8&scoped=true&ts=true"
import script from "./DashboardDetails.vue?vue&type=script&lang=ts"
export * from "./DashboardDetails.vue?vue&type=script&lang=ts"

import "./DashboardDetails.vue?vue&type=style&index=0&id=f4f0c5a8&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f0c5a8"]])

export default __exports__